export const GET_LMCATEGORIES_API_REQUEST = "GET_LMCATEGORIES_API_REQUEST";
export const GET_LMCATEGORIES_API_SUCCESS = "GET_LMCATEGORIES_API_SUCCESS";
export const GET_LMCATEGORIES_API_ERROR = "GET_LMCATEGORIES_API_ERROR";

export const POST_LMCATEGORIES_API_REQUEST = "POST_LMCATEGORIES_API_REQUEST";
export const POST_LMCATEGORIES_API_SUCCESS = "POST_LMCATEGORIES_API_SUCCESS";
export const POST_LMCATEGORIES_API_ERROR = "POST_LMCATEGORIES_API_ERROR";

export const GET_ENGINECATEGORY_API_REQUEST = "GET_ENGINECATEGORY_API_REQUEST";
export const GET_ENGINECATEGORY_API_SUCCESS = "GET_ENGINECATEGORY_API_SUCCESS";
export const GET_ENGINECATEGORY_API_ERROR = "GET_ENGINECATEGORY_API_ERROR";

export const ENGINECATEGORY_LOAD_MORE = "ENGINECATEGORY_LOAD_MORE"

export const EDIT_ENGINECATEGORY_SEARCH_QUERY = "EDIT_ENGINECATEGORY_SEARCH_QUERY"

export const EDIT_SELECTED_ENGINECATEGORY = "EDIT_SELECTED_ENGINECATEGORY"

export const EDIT_LIVE_CATEGORIES = "EDIT_LIVE_CATEGORIES"
